import { Component, Input, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import { PgRecorder } from '../../../../../common/audio-recording/pg-recorder';
import { MyModal } from './../../../../../common/my-modal/my-modal.component';
import { LoggerService } from './../../../../../../services/logger.service';
import { ConfigHelper } from '../../../../../../services/config.helper';
import * as ErrorMessages from '../../../../../../errors/constants';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'ipp-voice-recorder',
    template: require('./ipp-voice-recorder.component.html')
})
export class IppVoiceRecorderComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() recordTime: number;
    @Input() prepTime: number;
    @ViewChild('audioWrapper') audioWrapper: ElementRef;

    step: number = 1;
    currentProgress: number;
    infoBoxVisible: boolean;
    infoBoxText: string;
    infoBoxMode: string;
    iconCssClass: string;
    counterText: string;
    inputActivityLevel: number;
    playbackSubscription: Subscription;
    recordingSubscription: Subscription;
    inputActivitySubscription: Subscription;
    preparationSubscription: Subscription;
    recorder: PgRecorder;
    blob: Blob;
    audioPlayer: HTMLAudioElement;

    constructor(
        private elementRef: ElementRef,
        private myModal: MyModal,
        private loggerService: LoggerService,
        private zone: NgZone
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }

        if (this.playbackSubscription) {
            this.playbackSubscription.unsubscribe();
        }

        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }

        if (this.preparationSubscription) {
            this.preparationSubscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.audioPlayer = this.audioWrapper.nativeElement as HTMLAudioElement;
        this.audioPlayer.onended = () => {
            setTimeout(() => {
                this.showPlayButton();
            }, 1000);
        };
        this.audioPlayer.onloadeddata = () => {
            this.step = 4;

            this.currentProgress = 0;
            this.infoBoxVisible = true;
            this.infoBoxText = "Playing...";
            this.infoBoxMode = "ProgressBar";
            this.iconCssClass = 'play-icon';

            this.audioPlayer.play();

            const duration = this.recordTime + 1;
            this.playbackSubscription = Observable.interval(1000)
                .take(duration)
                .subscribe(
                    x => {
                        const timeElapsed = x + 1;
                        this.currentProgress = this.setProgress(timeElapsed, this.recordTime);
                    });
        };
    }

    start() {
        if (this.prepTime > 0) {
            this.startPreparation();
        } else {
            this.startRecording();
        }
    }

    startPreparation() {
        this.step = 2;
        this.infoBoxVisible = true;
        this.infoBoxText = "Preparation Time";
        this.infoBoxMode = "CountDownTimer";
        this.iconCssClass = 'clock-icon';
        this.counterText = this.prepTime.toString();
        this.inputActivityLevel = 100;
        this.preparationSubscription = Observable
            .interval(1000)
            .take(this.prepTime)
            .subscribe(x => {
                const timeElapsed = x + 1;
                const timeLeft = this.prepTime - timeElapsed;
                this.counterText = timeLeft >= 0 ? timeLeft.toString() : "--";
                if (timeLeft <= 0) {
                    this.startRecording();
                }
            });
    }

    startRecording() {
        PgRecorder.create(this.loggerService)
            .then(recorder => {
                this.recorder = recorder;
                this.step = 2;
                this.currentProgress = 0;
                this.recorder.start(this.showPlayButton);
                this.infoBoxVisible = true;
                this.infoBoxText = "Recording...";
                this.infoBoxMode = "ProgressBar";
                this.iconCssClass = 'rec-icon';
                this.recordingSubscription = Observable.interval(1000)
                    .take(this.recordTime)
                    .subscribe(x => {
                        const timeElapsed = x + 1;
                        this.currentProgress = this.setProgress(timeElapsed, this.recordTime);
                        if (timeElapsed >= this.recordTime) {
                            this.stopRecording();
                        }
                    });

                this.inputActivitySubscription = Observable.interval(200)
                    .subscribe(x => {
                        this.inputActivityLevel = 100 - this.recorder.getInputActivityLevel();
                    });
            })
            .catch(error => {
                const retry = "Retry";
                const cancel = "Cancel";
                const options = [{ label: retry, style: "btn-primary" }];
                if (ConfigHelper.canSkipMicrophoneCheck()) {
                    options.push({ label: cancel, style: "btn-secondary" });
                }

                this.myModal.showRegularDlg(
                    "Error",
                    ConfigHelper.isTdpMode() ? ErrorMessages.Microphone_Check_With_Code : ErrorMessages.Microphone_Check,
                    options)
                    .then(x => {
                        switch (x) {
                            case cancel:
                                break;
                            case retry:
                                this.startRecording();
                                break;
                        }
                    });
            });
    }

    stopRecording() {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }

        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }

        this.inputActivityLevel = 100;
        this.recorder.stop();
        this.blob = this.recorder.getBlob();
    }

    showPlayButton = () => {
        this.zone.run(() => {
            this.step = 3;
            this.infoBoxVisible = false;
            this.audioPlayer.src = "";
            if (this.playbackSubscription) {
                this.playbackSubscription.unsubscribe();
            }
        });
    }

    playRecording = () => {
        this.audioPlayer.src = window.URL.createObjectURL(this.blob);
    }

    setProgress(current: number, totalTime: number): number {
        return (current / totalTime) * 100;
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-voice-recorder/ipp-voice-recorder.component.ts